import { useLanguageTranslator } from "hooks/use-language-translator";
import { formFields } from "pages/cases-detail/constants";

export const useGetCategoriesList = () => {
  const { translator } = useLanguageTranslator();
  const categories = formFields?.map((item) => {
    return {
      value: item.key,
      label: `${item.id}. ${translator(`caseDetail.form.${item?.key}`)}`,
      id: item?.id,
    };
  });

  return { categories };
};
